import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { FeedInsertsListItem } from "../../content.types";
import { requestFeedInserts } from "./feedInserts.request";

const useFeedInserts = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<FeedInsertsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const queryClient = useQueryClient();
  const queryKey = ["feed-inserts", "all", requestParams];

  const { data, ...rest } = useQuery({
    queryKey,
    queryFn: async () => await requestFeedInserts(requestParams),
    ...options
  });

  const setFeedInserts = (newBanners: FeedInsertsListItem[]) => {
    queryClient.setQueriesData(queryKey, {
      data: newBanners,
      meta: data?.meta
    });
  };

  return { feedInserts: data?.data, meta: data?.meta, setFeedInserts, ...rest };
};

export default useFeedInserts;
